import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { HttpServiceInterceptor } from './http-service.interceptor'

export const httpInterceptorProviders = [{ provide: HTTP_INTERCEPTORS, useClass: HttpServiceInterceptor, multi: true }]
